// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_m5-1";
export var rowFirst = "_m5-3";
export var rowLast = "_m5-5";
export var rowMiddle = "_m5-4";
export var ticketListScroll = "_m5-2";
export var ticketStack = "_m5-0";